const rankingItems = [
  { rank: 1, title: '最新院线大片专区', heat: '今日播放 9.8万次', trend: 'up', icon: 'ri-medal-fill', color: 'text-amber-500' },
  { rank: 2, title: '国产剧热播排行榜', heat: '今日播放 8.5万次', trend: 'up', icon: 'ri-medal-fill', color: 'text-gray-400' },
  { rank: 3, title: '韩剧精选热追榜', heat: '今日播放 7.9万次', trend: 'up', icon: 'ri-medal-fill', color: 'text-orange-400' },
  { rank: 4, title: '动漫番剧更新速递', heat: '今日播放 6.6万次', trend: 'down', icon: '', color: 'text-foreground-400' },
  { rank: 5, title: '综艺节目欢乐合集', heat: '今日播放 5.8万次', trend: 'up', icon: '', color: 'text-foreground-400' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            人气排行
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">今日最受关注的影视内容排行榜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3">
            {rankingItems.map((item) => (
              <a
                key={item.rank}
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                  {item.rank <= 3 ? (
                    <i className={`${item.icon} text-2xl ${item.color}`}></i>
                  ) : (
                    <span className="font-heading font-bold text-lg text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                  {item.trend === 'up' ? (
                    <i className="ri-arrow-up-line text-accent-600"></i>
                  ) : (
                    <i className="ri-arrow-down-line text-foreground-400"></i>
                  )}
                  <span className="text-xs text-foreground-500 font-label whitespace-nowrap">{item.heat}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}